module.exports = __webpack_public_path__ + "static/olistic-MONEI-15d1ce8bca4d7878acd32744e19c6730.png";